<template>
<v-card class="box-shadow-custom">
    <v-snackbar v-model="snackbar" :timeout="2000" bottom right dark>
        <v-icon color="white">mdi-checkbox-marked-circle-outline</v-icon>
        Copied
        <v-btn text @click="snackbar = false">
            <v-icon>mdi-close</v-icon>
        </v-btn>
    </v-snackbar>
    <div class="pa-5 pt-10">
        <v-row>
            <v-col cols="12" md="6" class="py-0">
                <v-text-field dense class="border-radius" v-clipboard:copy="key" v-clipboard:success="onCopy" v-clipboard:error="onError" outlined label="API Key" prepend-inner-icon="mdi-content-copy" :value="key"></v-text-field>
            </v-col>
            <v-col cols="12" md="12" class="py-0">
                <v-card-actions class="px-0">
                    <span class="grey--text">If you need any help with Custom Integration please email to <a href="mailto:support@offersoptimize.com">support@offersoptimize.com</a></span>
                    <v-spacer></v-spacer>
                    <span class="grey--text">OffersOptimize's API Documentation <a href="https://docs.offersoptimize.com" target="_block">Click Here</a></span>
                </v-card-actions>
            </v-col>
        </v-row>
    </div>
    <v-divider></v-divider>
    <iframe id="the-iframe" width="100%" style="height: 75vh" src="https://docs.offersoptimize.com" frameborder="0"></iframe>
</v-card>
</template>

<script>
import VueClipboard from 'vue-clipboard2'
import Vue from 'vue'
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
import {
    mapMutations
} from 'vuex'
export default {
    data() {
        return {
            snackbar: false,
            key: window.localStorage.getItem('userToken'),
            dialog: false
        }
    },
    methods: {
        ...mapMutations(['SnackbarSuccess']),
        onCopy(e) {
            let dataMsg = { success : true, message : 'Copy Successfully', action : 'success' }
            this.SnackbarSuccess(dataMsg)
        },
        onError(e) {
            let dataMsg = { success : true, message : 'Copy '+ e.text, action : 'error' }
            this.SnackbarSuccess(dataMsg)
        }
    }
}
</script>
